(() => {
  "use strict";

  // Installing is what makes notifications possible at all on an iPhone: iOS delivers
  // Web Push to Home Screen web apps and never to a Safari tab. So this sits beside the
  // notification switch rather than somewhere decorative, and on iOS it is the first
  // thing a person has to do, not an optional extra.

  let hooks = null;
  let deferred = null;

  function installed() {
    try {
      return window.matchMedia("(display-mode: standalone)").matches
        || window.navigator.standalone === true;
    } catch (_) {
      return window.navigator.standalone === true;
    }
  }

  // Detected from the touch and platform surface rather than the user-agent string,
  // because iPadOS reports a desktop Mac user agent and would be missed by a name match.
  function isApple() {
    const platform = navigator.platform || "";
    const touch = navigator.maxTouchPoints || 0;
    return /iPad|iPhone|iPod/.test(platform) || (platform === "MacIntel" && touch > 1);
  }

  const STEPS = [
    "Open LOUDERR in Safari.",
    "Tap the Share button at the bottom of the screen.",
    "Choose Add to Home Screen.",
    "Open LOUDERR from the icon it makes.",
  ];

  function paint() {
    if (!hooks) return;
    const { section, status, button, steps } = hooks;
    if (!section) return;
    section.hidden = false;
    steps.replaceChildren();
    if (installed()) {
      button.hidden = true;
      steps.hidden = true;
      status.textContent = "LOUDERR is installed on this device.";
      return;
    }
    if (deferred) {
      button.hidden = false;
      steps.hidden = true;
      status.textContent = "Install LOUDERR for a faster start and notifications when it is closed.";
      return;
    }
    button.hidden = true;
    if (isApple()) {
      steps.hidden = false;
      status.textContent =
        "On iPhone and iPad, notifications only reach LOUDERR once it is on your Home Screen.";
      for (const text of STEPS) {
        const item = document.createElement("li");
        item.textContent = text;
        steps.append(item);
      }
      return;
    }
    steps.hidden = true;
    // Firefox and desktop Safari never fire the prompt event, and inventing a button
    // that cannot do anything is worse than saying nothing.
    status.textContent = "Use your browser's own menu to install LOUDERR on this device.";
  }

  async function install() {
    if (!deferred) return;
    const prompt = deferred;
    deferred = null;
    hooks.button.disabled = true;
    try {
      prompt.prompt();
      const choice = await prompt.userChoice;
      if (choice?.outcome !== "accepted") hooks.toast("LOUDERR was not installed.");
    } catch (_) {
      hooks.toast("The install could not be started.");
    } finally {
      hooks.button.disabled = false;
      paint();
    }
  }

  globalThis.LouderrInstall = {
    connect(options) {
      hooks = options;
      window.addEventListener("beforeinstallprompt", (event) => {
        // Held rather than allowed to run: the browser's own banner interrupts, and this
        // belongs next to the explanation of what installing is for.
        event.preventDefault();
        deferred = event;
        paint();
      });
      window.addEventListener("appinstalled", () => { deferred = null; paint(); });
      hooks.button?.addEventListener("click", () => void install());
      paint();
    },
    paint,
    installed,
    isApple,
    steps: () => STEPS.slice(),
  };
})();
